/**
 * Tries to get the content of type `type` from the clipboard.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @param {'text'|'data'} type        the type of content
 * @returns {(function(): Promise<string|ClipboardItem[]|null>)|*}
 */
const fn = (app, type) => async () => {
  try {
    return type === 'text'
      ? await navigator.clipboard.readText()
      : await navigator.clipboard.read()
  } catch (e) {
    console.error(e)
  }

  return null
}
export default fn
